export const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000", 
    oneMapApiUrl: "https://www.onemap.gov.sg/api/common/elastic/search?searchVal=" 
};




